export default __webpack_public_path__ + "static/media/last-quarter.d6319b06.svg";